/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_0_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a copy and a clear baseline`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先准备副本和核对基准`)
};

/**
* | output |
* | --- |
* | "Start with a copy and a clear baseline" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_0_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_0_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_0_title as "gc.search_guides.gridcraft_excel_compatibility.sections.0.title" }